import React from 'react';

export const receiptPaymentStatus = (receipt) => {
  // Compare integer minor units, matching the receipt balance calculation.
  const gross = Math.round(Number(receipt.gross_amount || 0) * 100);
  const paid = Math.round(Number(receipt.payment_total ?? receipt.paid_amount ?? 0) * 100);
  const direction = gross < 0 ? -1 : 1;
  const remaining = Math.max(0, (gross - paid) * direction);
  const tolerance = receipt.currency === 'HUF' ? 50 : 0.5;
  const state = remaining <= tolerance ? 'paid' : paid * direction > 0 ? 'partial' : 'unpaid';
  return {state, paid: paid / 100, remaining: remaining / 100};
};

// The application formatter returns a React fragment, while native tooltips need text.
const currencyText = value => {
  if (value == null || typeof value === 'boolean') return '';
  if (Array.isArray(value)) return value.map(currencyText).join('');
  if (React.isValidElement(value)) return currencyText(value.props.children);
  return String(value);
};

export default function ReceiptPaymentStatus({receipt, t, formatCurrency}) {
  const {state, paid, remaining} = receiptPaymentStatus(receipt);
  const tooltip = `${t(`receiptPaymentStatus.${state}`)}\n${t('receiptPaymentStatus.paidAmount')}: ${currencyText(formatCurrency(receipt.currency, paid))}\n${t('receiptPaymentStatus.remainingAmount')}: ${currencyText(formatCurrency(receipt.currency, remaining))}`;
  const color = {paid: '#2e7d32', partial: '#b96700', unpaid: '#757575'}[state];
  return (
    <span title={tooltip} aria-label={tooltip} tabIndex={0} style={{display: 'inline-flex', color}}>
      {state === 'paid' ? <i className="pi pi-check" aria-hidden="true" /> : (
        <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
          <circle cx="8" cy="8" r="6" fill="none" stroke="currentColor" strokeWidth="1.5" />
          {state === 'partial' && <path d="M8 2a6 6 0 0 0 0 12Z" fill="currentColor" />}
        </svg>
      )}
    </span>
  );
}
